export const COMMUNICATIONS_FIELD = "communications";
export const LOGIN_CONSENTS_ERROR_ALERT_ID = "LOGIN_CONSENTS_ERROR_ALERT_ID";
export const LOGIN_CONSENTS_TIMEOUT_ERROR = {
	code: "E_CUSTOMERCONSENT_FORBIDDEN",
	type: 403,
};

export const LOGIN_CONSENTS_TRANSLATION_KEYS = {
	generalClose: "general.close",
	generalContactCustomerSupport: "general.contact-customer-support",
	generalGenericError: "general.generic-error",
	generalConsentsCommunicationCaptionGroup: "login-consents.communications.caption.group",
	loginConsentsCommunicationsCaptionOnlyGroup: "login-consents.communications.caption.only.group",
	loginConsentsCommunicationsCaptionBrand: "login-consents.communications.caption.brand",
	loginConsentsCaptionDutchRegister: "login-consents.caption.dutch-register",
	loginConsentsCaptionRegister: "login-consents.caption.register",
	loginConsentsCaptionLogin: "login-consents.caption.login",
	loginConsentsCaptionLoginBrand: "login-consents.caption.login.brand",
	loginConsentsTitleError: "login.title.login-error",
	generalYes: "general.yes",
	generalNo: "general.no",
	loginConsentsCommunicationsAcceptBrand: "login-consents.communications.accept.brand",
	loginConsentsCommunicationsDeclineBrand: "login-consents.communications.decline.brand",
};
